// extracted by mini-css-extract-plugin
export default {"carouselGrid12":"aivvIi","external":"bivvIi","carouselGrid16":"civvIi","carouselGrid8":"divvIi"};